/* eslint-disable */
import Vue from 'vue'
import { handleResponse, logout } from '../_helpers'

function getAccessToken(token) {

    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return fetch(`${Vue.appConfig.apiBaseUrl}/login/accesstoken?token=${token}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            // login successful if there's a jwt token in the response
            if (response.data.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(response.data));
            }
            return response.data;
        });
}

export const loginService = {
    getAccessToken: getAccessToken,
    logout: logout
};